import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor() {}
  private subject = new Subject<any>();
  private isQuestionSaved = new Subject<any>();

  Navigate(homePage: string, childPage: string) {
    this.subject.next({ HomePage: homePage, ChildPage: childPage });
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  setQuestionsSaved() {
    this.isQuestionSaved.next(true);
  }
  getIsQuestionSaved(): Observable<any> {
    return this.isQuestionSaved.asObservable();
  }
}
